export const ConditionOptions = [
  { value: "A receber", label: "A receber" },
  { value: "A pagar", label: "A pagar" },
  { value: "Pago", label: "Pago" },
  { value: "Recebido", label: "Recebido" }
]